import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import get from 'lodash/get';
import find from 'lodash/find';
import Strings from '@kfc-global/react-shared/constants/Strings';
import { getContentCall } from '@kfc-global/react-shared/redux/Actions/ContentAction';
import { ChannelManager } from 'common/manager';
import { NotFound } from 'components/NotFound/Container/NotFound';
import { useLocation, useParams } from 'react-router-dom';
import {
  aminityFeatureData,
  collectionPointData,
  deliveryOptionData,
  getStoreChannelsDetails,
} from 'organisms/SearchStore/AU/SearchStoreUtilities/SearchStoreUtils';
import {
  detailsContentFull,
  getBulkStoreStatus,
  getRestaurantDetails,
} from '@kfc-global/react-shared/redux/Actions/StoresAction';
import {
  getValueOrDefaultObject,
  getValueOrnull,
  getTernaryValue,
  checkByParams,
  getHeaderContentData,
  isEmptyObject,
  isMobileDevice,
  getFullAddressDetails,
  tradingHrsData,
} from 'common/utilities/utils';
import { StructureData } from 'organisms/StructureDataComponent';
import { Config, PHONE_NUMBER, RESIZE, RESTAURANT_PAGE, SEO_OPTIONS, PICK_UP } from 'common/constants/SharedConstants';
import { LoyaltyCrmContainer } from 'organisms/LoyaltyCrmSignupComponent';
import { getCmsClient } from 'common/utilities/cmsClient';
import RestaurantMapView from 'organisms/RestaurantDetailPage/Presentation/RestaurantMapView';
import RestaurantDetailsView from 'organisms/RestaurantDetailPage/Presentation/RestaurantDetailsView';
import PlaceholderRDPComponent from 'organisms/RestaurantDetailPage/Presentation/PlaceholderComponentView';
import filter from 'lodash/filter';

const RestaurantDetailComponent = () => {
  const storeData = useSelector(data => getValueOrDefaultObject(data.storesReducer));
  const {
    selectedRestaurantDetailsDL,
    storeDetailsContentFull,
    selectedRestaurantDetailsDLError,
    isRestaurantDetailsLoading,
  } = storeData;
  const allContentData = useSelector(data => {
    return {
      homePageContent: get(data, 'contentReducer.response', null),
    };
  });
  const { store_name = '', post_code = '' } = useParams();
  const [seoPage, setSeoPage] = useState();
  const [seoObj, setSeoObj] = useState();
  const [seoData, setSeoData] = useState(null);
  const [summaryDetail, setSummaryDetails] = useState([]);
  const [loadGoogleMap, setGoogleMap] = useState(false);
  const [storeDetail, setStoreDetail] = useState({});
  const tenantReducer = useSelector(state => state?.tenantReducer);
  const storeNumberFormat = tenantReducer?.componentOptions?.web?.restaurantDetailPage?.storeNumberFormat;
  const userParams = useSelector(data => data?.appStateReducer?.userStatus);
  const [isMobile, setIsMobile] = useState(isMobileDevice(window.innerWidth));
  const {
    tenantId,
    componentOptions: {
      web: { rdpPage },
    },
  } = tenantReducer;

  const location = useLocation();
  const dispatch = useDispatch();
  const [segmentedHomePageData, setSegmentedHomePageData] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    /* istanbul ignore next */
    if (allContentData?.homePageContent) {
      setSegmentedHomePageData(getValueOrnull(getHeaderContentData(allContentData?.homePageContent)));
    }
  }, [allContentData?.homePageContent]);

  useEffect(() => {
    dispatch(
      getContentCall({
        object: getCmsClient(),
        contentFull: {
          content_type: 'landingPage',
          'fields.channel': ChannelManager.channel,
          include: '5',
        },
        userParams,
      }),
    );
    dispatch(
      detailsContentFull({
        object: getCmsClient(),
        contentFull: {
          content_type: 'aggregatorImage',
          include: '5',
        },
      }),
    );
  }, [dispatch, tenantId, location?.state?.storeId, userParams]);

  useEffect(() => {
    dispatch(
      getRestaurantDetails(
        {
          storeName: store_name,
          postCode: post_code,
          tenantId,
        },
        restaurantResponse => {
          const statusCallPayload = {
            data: [
              {
                channel: ChannelManager.channel,
                service: PICK_UP,
                storeId: restaurantResponse?.id || location?.state?.storeId,
              },
            ],
            tenantId,
          };
          dispatch(
            getBulkStoreStatus(statusCallPayload, storeInfo => {
              setSummaryDetails(storeInfo);
            }),
          );
        },
      ),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  useEffect(() => {
    if (selectedRestaurantDetailsDL && Object.keys(selectedRestaurantDetailsDL).length) {
      setStoreDetail({
        service: summaryDetail[0]?.service,
        summary: summaryDetail[0]?.summary,
        ...selectedRestaurantDetailsDL,
      });
    }
  }, [selectedRestaurantDetailsDL, summaryDetail]);

  useEffect(() => {
    const timer = setInterval(() => {
      if (window.google) {
        setGoogleMap(true);
        clearInterval(timer);
      }
    }, 100);
  }, [setGoogleMap]);

  useEffect(() => {
    setSeoData(allContentData?.homePageContent?.seoStructureData?.seo);
    const aggregatorObj = getValueOrDefaultObject(storeDetailsContentFull?.details?.fields?.icons);
    const restaurantImg = getValueOrnull(
      find(aggregatorObj, item => item?.fields?.category === Config.VIEWPORT_AGENT_BROWSER),
    );
    const { state, city, pinCode } = getValueOrDefaultObject(
      storeDetail?.addresses && storeDetail?.addresses[0]?.address,
    );
    const tradingHrsObject = tradingHrsData(storeDetail?.availableTradingHours);

    const serviceOption =
      storeDetail &&
      Object.keys(storeDetail).length &&
      collectionPointData(storeDetail?.availableCollectionPoints, SEO_OPTIONS);

    const deliveryOption = deliveryOptionData(storeDetail?.availableServicesPerChannel);
    if (serviceOption && deliveryOption) {
      const result = [...serviceOption, ...deliveryOption];
      const seoObjData = {
        StoreName: getValueOrnull(storeDetail?.summary?.name),
        StoreOptions: getStoreChannelsDetails(storeDetail, '', SEO_OPTIONS)?.orderTypes?.join(', '),
        StoreImage: `${Strings.https}${restaurantImg?.fields?.desktopImage?.fields?.file?.url}`,
        StoreLat: getValueOrnull(storeDetail?.location?.latitude)?.toString(),
        StoreLong: getValueOrnull(storeDetail?.location?.longitude)?.toString(),
        StoreLocation: city,
        StoreAddress: getFullAddressDetails(storeDetail?.addresses && storeDetail?.addresses[0]?.address),
        StorePostcode: pinCode,
        StoreRegion: state,
        StoreAmenities: aminityFeatureData(result),
        StorePhone: filter(storeDetail?.contacts, ['key', PHONE_NUMBER])[0]?.value,
        ...tradingHrsObject,
      };
      setSeoObj(seoObjData);
      setSeoPage(RESTAURANT_PAGE);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [seoData, storeDetail, allContentData?.homePageContent, storeDetailsContentFull?.details?.fields?.icons]);

  /**
   * Method call on window resize
   */
  const windowResized = () => {
    const isMobileView = isMobileDevice(window.innerWidth);
    setIsMobile(isMobileView);
  };
  /**
   * Use to add window listner for windown size change
   */
  useEffect(() => {
    window.addEventListener(RESIZE, windowResized);
    return () => {
      window.removeEventListener(RESIZE, windowResized);
    };
  }, [isMobile]);

  return getTernaryValue(
    !selectedRestaurantDetailsDLError,
    <>
      {checkByParams(seoObj, <StructureData page={seoPage} seoObj={seoObj} />)}

      {checkByParams(
        isEmptyObject(storeDetail),
        loadGoogleMap,
        rdpPage.rdpMap,
        <RestaurantMapView isMobile={isMobile} latLong={storeDetail?.location} />,
      )}

      {checkByParams(isRestaurantDetailsLoading, <PlaceholderRDPComponent />)}

      {checkByParams(
        isEmptyObject(storeDetail),
        <RestaurantDetailsView
          loggedIn={userParams?.loggedIn}
          isMobile={isMobile}
          restarantDetails={storeDetail}
          restrauntContentful={storeDetailsContentFull}
          storeNumberFormat={storeNumberFormat}
        />,
      )}
      {(!isRestaurantDetailsLoading &&
        isEmptyObject(storeDetail) &&
        isEmptyObject(segmentedHomePageData) &&
        rdpPage.rdpLickinFingerBlk &&
        segmentedHomePageData['crmSignUp'] && (
          <LoyaltyCrmContainer
            customTag='h3'
            contentData={getValueOrDefaultObject(segmentedHomePageData['crmSignUp'])}
          />
        )) ||
        null}
    </>,
    <NotFound />,
  );
};

const RestaurantDetailComponentSection = React.memo(RestaurantDetailComponent);
export default RestaurantDetailComponentSection;
